<script>
  import { createEventDispatcher } from "svelte"
  import SinInformacion from "../Sin_informacion.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"

  const dispatch = createEventDispatcher()

  let session_key = $user.session_key

  let segmentos = []
  let segmento = {
    nombre: "",
    descripcion: "",
  }
  let isAdding = false

  const addSegmento = async () => {
    if (segmento.nombre.trim() === "" || segmento.descripcion.trim() === "") {
      alert("Por favor, complete todos los campos.")
      return
    }

    if (segmentos.some((seg) => seg.nombre === segmento.nombre)) {
      alert("El nombre del segmento ya existe.")
      return
    }

    isAdding = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "addSegmento",
        nombre: segmento.nombre,
        descripcion: segmento.descripcion,
        session_key: session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      getSegmentos()
    } else {
      alert(data.message || "Error al agregar el segmento.")
    }
    isAdding = false
  }

  const getSegmentos = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getSegmentos&session_key=${session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      segmentos = data.data
    } else {
      segmentos = []
    }
    dispatch("update", segmentos)
  }

  const desactivarSegmento = async (id, nombre) => {
    if (
      !confirm(
        `¿Está seguro de que desea desactivar el segmento: ${nombre}? \n Los clientes pasaran a (perdido)`,
      )
    ) {
      return
    }

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "desactivarSegmento",
        id: id,
        session_key: session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      getSegmentos()
    } else {
      alert(data.message || "Error al desactivar el segmento.")
    }
  }

  getSegmentos()
</script>

<div>
  <div class="row g-3">
    <div class="col-12 lg:col-6">
      <label for="segmento_nombre" class="form-label small fg-secondary"
        >Nombre</label
      >
      <input
        type="text"
        id="segmento_nombre"
        class="form-control form-control-sm"
        placeholder="Ingrese el nombre del segmento"
        bind:value={segmento.nombre}
      />
    </div>
    <div class="col-12 lg:col-6">
      <label for="segmento_descripcion" class="form-label small fg-secondary"
        >Descripción</label
      >
      <input
        type="text"
        id="segmento_descripcion"
        class="form-control form-control-sm"
        placeholder="Ingrese la descripción del segmento"
        bind:value={segmento.descripcion}
      />
    </div>
    <div class="col-12 text-end">
      {#if isAdding}
        <button class="btn btn-solid theme-primary btn-sm disabled" disabled
          ><i class="bi bi-plus"></i>Agregando...</button
        >
      {:else}
        <button
          class="btn btn-solid theme-primary btn-sm"
          on:click={addSegmento}><i class="bi bi-plus"></i>Agregar</button
        >
      {/if}
    </div>
  </div>

  <div class="table-responsive mb-3">
    <table class="table table-striped table-sm small">
      <thead>
        <tr>
          <th class="fg-secondary fw-normal">Nombre</th>
          <th class="fg-secondary fw-normal">Descripción</th>
          <th class="fg-secondary fw-normal"></th>
        </tr>
      </thead>
      <tbody>
        {#each segmentos as segmento}
          <tr>
            <td>{segmento.nombre}</td>
            <td>{segmento.descripcion}</td>
            <td class="text-end">
              {#if segmento.estado == "1"}
                <button
                  class="btn btn-solid btn-xs theme-danger py-0 px-1"
                  on:click={() =>
                    desactivarSegmento(segmento.id, segmento.nombre)}
                >
                  <small>Desactivar</small>
                </button>
              {:else}
                <span class="badge badge-subtle theme-secondary">Inactivo</span>
              {/if}
            </td>
          </tr>
        {:else}
          <tr>
            <td colspan="2" class="text-center">
              <SinInformacion message="No hay segmentos para mostrar" />
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>
